var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("buy-modal"),
      _c("section", { staticClass: "pricing__section pricing__section--bg" }, [
        _c("div", { staticClass: "pricing__container" }, [
          _c("div", { staticClass: "pricing__container--title" }, [
            _c("h1", [_vm._v("Choose the plan that’s right for you")]),
            _c("p", [
              _vm._v(
                "Whether you’re a Marketer, Photographer, Designer, Agency, or Enterprise, there’s a plan with Flixel apps and web services for your business."
              )
            ]),
            _c("div", { staticClass: "toggle__container" }, [
              _c(
                "div",
                {
                  staticClass: "toggle__item",
                  class: { toggleitemactive: !_vm.showingMonthly },
                  attrs: { id: "toggle__item--yearly" },
                  on: {
                    click: function($event) {
                      _vm.showYearly()
                    }
                  }
                },
                [_c("p", [_vm._v("Yearly")])]
              ),
              _c(
                "div",
                {
                  staticClass: "toggle__item",
                  class: { toggleitemactive: _vm.showingMonthly },
                  attrs: { id: "toggle__item--monthly" },
                  on: {
                    click: function($event) {
                      _vm.showMonthly()
                    }
                  }
                },
                [_c("p", [_vm._v("Monthly")])]
              )
            ]),
            _c("p", { staticClass: "pricing__container--toggle" }, [
              _vm._v("Save up to 50% with a yearly plan!")
            ])
          ]),
          _c("div", { staticClass: "pricing__container--grid" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showingBlendeo,
                    expression: "showingBlendeo"
                  }
                ],
                staticClass: "gridItem",
                attrs: { id: "mobile" }
              },
              [
                _vm._m(0),
                _vm._m(1),
                _vm.showingMonthly
                  ? _c("div", { staticClass: "gridItem--pricing" }, [
                      _c("h4", [
                        _vm._v(_vm._s(_vm.blendeoMonthly)),
                        _c("span", [_vm._v(" / month")])
                      ]),
                      _c("p", [
                        _vm._v(
                          "Save " + _vm._s(_vm.blendeoYearlySave) + " with  "
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "link",
                            on: {
                              click: function($event) {
                                _vm.showYearly()
                              }
                            }
                          },
                          [_vm._v("yearly billing")]
                        )
                      ])
                    ])
                  : _vm._e(),
                !_vm.showingMonthly
                  ? _c("div", { staticClass: "gridItem--pricing" }, [
                      _c("h4", [
                        _vm._v(_vm._s(_vm.blendeoYearlyPerMonth)),
                        _c("span", [_vm._v("/ month")])
                      ]),
                      _c("p", [
                        _c("span", [_vm._v(_vm._s(_vm.blendeoYearly) + " ")]),
                        _vm._v("billed yearly. ")
                      ]),
                      _c("p", [
                        _vm._v(
                          "Save " + _vm._s(_vm.blendeoYearlySave) + " over  "
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "link",
                            on: {
                              click: function($event) {
                                _vm.showMonthly()
                              }
                            }
                          },
                          [_vm._v("monthly billing")]
                        )
                      ])
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "gridItem--pricing" },
                  [
                    _vm.showingMonthly
                      ? _c("buy-button", {
                          attrs: {
                            classes: "btn btn--purpleLight",
                            product: "blendeo-month",
                            copy: "Buy Now"
                          }
                        })
                      : _vm._e(),
                    !_vm.showingMonthly
                      ? _c("buy-button", {
                          attrs: {
                            classes: "btn btn--purpleLight",
                            product: "blendeo-year",
                            copy: "Buy Now"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _c("div", { staticClass: "gridItem--subtitle" }, [
                  _c("h5", { staticClass: "includeTitleDesktop" }, [
                    _vm._v("Includes:")
                  ]),
                  _c("h5", { staticClass: "includeTitleMobile" }, [
                    _vm._v("Includes:")
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "moreFeatures",
                      attrs: { id: "moreFeaturesMobile" },
                      on: {
                        click: function($event) {
                          _vm.showFeature(
                            "mobile",
                            "moreFeaturesMobile",
                            "featuresMobile"
                          )
                        }
                      }
                    },
                    [
                      _c("h5", [_vm._v("Show Features")]),
                      _c("i", { staticClass: "fa fa-chevron-down" })
                    ]
                  )
                ]),
                _vm._m(2),
                _vm._m(3)
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showingPersecond,
                    expression: "showingPersecond"
                  }
                ],
                staticClass: "gridItem",
                attrs: { id: "mobile" }
              },
              [
                _vm._m(4),
                _vm._m(5),
                _vm.showingMonthly
                  ? _c("div", { staticClass: "gridItem--pricing" }, [
                      _c("h4", [
                        _vm._v(_vm._s(_vm.persecondMonthly)),
                        _c("span", [_vm._v(" / month")])
                      ]),
                      _c("p", [
                        _vm._v(
                          "Save " + _vm._s(_vm.persecondYearlySave) + " with  "
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "link",
                            on: {
                              click: function($event) {
                                _vm.showYearly()
                              }
                            }
                          },
                          [_vm._v("yearly billing")]
                        )
                      ])
                    ])
                  : _vm._e(),
                !_vm.showingMonthly
                  ? _c("div", { staticClass: "gridItem--pricing" }, [
                      _c("h4", [
                        _vm._v(_vm._s(_vm.persecondYearlyPerMonth)),
                        _c("span", [_vm._v("/ month")])
                      ]),
                      _c("p", [
                        _c("span", [_vm._v(_vm._s(_vm.persecondYearly) + " ")]),
                        _vm._v("billed yearly. ")
                      ]),
                      _c("p", [
                        _vm._v(
                          "Save " + _vm._s(_vm.persecondYearlySave) + " over  "
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "link",
                            on: {
                              click: function($event) {
                                _vm.showMonthly()
                              }
                            }
                          },
                          [_vm._v("monthly billing")]
                        )
                      ])
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "gridItem--pricing" },
                  [
                    _vm.showingMonthly
                      ? _c("buy-button", {
                          attrs: {
                            classes: "btn btn--purpleLight",
                            product: "fpsmac-month",
                            copy: "Buy Now"
                          }
                        })
                      : _vm._e(),
                    !_vm.showingMonthly
                      ? _c("buy-button", {
                          attrs: {
                            classes: "btn btn--purpleLight",
                            product: "fpsmac-year",
                            copy: "Buy Now"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _c("div", { staticClass: "gridItem--subtitle" }, [
                  _c("h5", { staticClass: "includeTitleDesktop" }, [
                    _vm._v("Includes:")
                  ]),
                  _c("h5", { staticClass: "includeTitleMobile" }, [
                    _vm._v("Includes:")
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "moreFeatures",
                      attrs: { id: "moreFeaturesMobile" },
                      on: {
                        click: function($event) {
                          _vm.showFeature(
                            "mobile",
                            "moreFeaturesMobile",
                            "featuresMobile"
                          )
                        }
                      }
                    },
                    [
                      _c("h5", [_vm._v("Show Features")]),
                      _c("i", { staticClass: "fa fa-chevron-down" })
                    ]
                  )
                ]),
                _vm._m(6),
                _vm._m(7)
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.showingPersecond || _vm.showingBlendeo,
                    expression: "!showingPersecond || showingBlendeo"
                  }
                ],
                staticClass: "gridItem",
                attrs: { id: "mobile" }
              },
              [
                _vm._m(8),
                _vm._m(9),
                _vm.showingMonthly
                  ? _c("div", { staticClass: "gridItem--pricing" }, [
                      _c("h4", [
                        _vm._v(_vm._s(_vm.mobileMonthly)),
                        _c("span", [_vm._v(" / month")])
                      ]),
                      _c("p", [
                        _vm._v(
                          "Save " + _vm._s(_vm.mobileYearlySave) + " with"
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "link",
                            on: {
                              click: function($event) {
                                _vm.showYearly()
                              }
                            }
                          },
                          [_vm._v(" yearly billing")]
                        )
                      ])
                    ])
                  : _vm._e(),
                !_vm.showingMonthly
                  ? _c("div", { staticClass: "gridItem--pricing" }, [
                      _c("h4", [
                        _vm._v(_vm._s(_vm.mobileYearlyPerMonth)),
                        _c("span", [_vm._v(" / month")])
                      ]),
                      _c("p", [
                        _c("span", [
                          _vm._v(_vm._s(_vm.mobileYearly) + " billed yearly.")
                        ])
                      ]),
                      _c("p", [
                        _vm._v(
                          "Save " + _vm._s(_vm.mobileYearlySave) + " over"
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "link",
                            on: {
                              click: function($event) {
                                _vm.showMonthly()
                              }
                            }
                          },
                          [_vm._v(" monthly billing")]
                        )
                      ])
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "gridItem--pricing" },
                  [
                    _vm.showingMonthly
                      ? _c("buy-button", {
                          attrs: {
                            classes: "btn btn--purpleLight",
                            product: "fmp-m",
                            copy: "Buy Now"
                          }
                        })
                      : _vm._e(),
                    !_vm.showingMonthly
                      ? _c("buy-button", {
                          attrs: {
                            classes: "btn btn--purpleLight",
                            product: "fmp-y",
                            copy: "Buy Now"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _c("div", { staticClass: "gridItem--subtitle" }, [
                  _c("h5", { staticClass: "includeTitleDesktop" }, [
                    _vm._v("Includes:")
                  ]),
                  _c("h5", { staticClass: "includeTitleMobile" }, [
                    _vm._v("Includes:")
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "moreFeatures",
                      attrs: { id: "moreFeaturesMobile" },
                      on: {
                        click: function($event) {
                          _vm.showFeature(
                            "mobile",
                            "moreFeaturesMobile",
                            "featuresMobile"
                          )
                        }
                      }
                    },
                    [
                      _c("h5", [_vm._v("Show Features")]),
                      _c("i", { staticClass: "fa fa-chevron-down" })
                    ]
                  )
                ]),
                _vm._m(10),
                _vm._m(11)
              ]
            ),
            _c("div", { staticClass: "gridItem", attrs: { id: "pro" } }, [
              _vm._m(12),
              _vm._m(13),
              _vm.showingMonthly
                ? _c("div", { staticClass: "gridItem--pricing" }, [
                    _c("h4", [
                      _vm._v(_vm._s(_vm.proMonthly)),
                      _c("span", [_vm._v(" / month")])
                    ]),
                    _c("p", [
                      _vm._v("Save " + _vm._s(_vm.proYearlySave) + " with"),
                      _c(
                        "a",
                        {
                          staticClass: "link",
                          on: {
                            click: function($event) {
                              _vm.showYearly()
                            }
                          }
                        },
                        [_vm._v(" yearly billing")]
                      )
                    ])
                  ])
                : _vm._e(),
              !_vm.showingMonthly
                ? _c("div", { staticClass: "gridItem--pricing" }, [
                    _c("h4", [
                      _vm._v(_vm._s(_vm.proYearlyPerMonth)),
                      _c("span", [_vm._v(" / month")])
                    ]),
                    _c("p", [
                      _vm._v(_vm._s(_vm.proYearly) + " billed yearly.")
                    ]),
                    _c("p", [
                      _vm._v("Save " + _vm._s(_vm.proYearlySave) + " over"),
                      _c(
                        "a",
                        {
                          staticClass: "link",
                          on: {
                            click: function($event) {
                              _vm.showMonthly()
                            }
                          }
                        },
                        [_vm._v(" monthly billing")]
                      )
                    ])
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "gridItem--pricing" },
                [
                  _vm.showingMonthly
                    ? _c("buy-button", {
                        attrs: {
                          classes: "btn btn--purpleLight",
                          product: "fpp-m",
                          copy: "Buy Now"
                        }
                      })
                    : _vm._e(),
                  !_vm.showingMonthly
                    ? _c("buy-button", {
                        attrs: {
                          classes: "btn btn--purpleLight",
                          product: "fpp-y",
                          copy: "Buy Now"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c("div", { staticClass: "gridItem--subtitle" }, [
                _c("h5", { staticClass: "includeTitleDesktop" }, [
                  _vm._v("Includes:")
                ]),
                _c("h5", { staticClass: "includeTitleMobile" }, [
                  _vm._v("Includes:")
                ]),
                _c(
                  "div",
                  {
                    staticClass: "moreFeatures",
                    attrs: { id: "moreFeaturesPro" },
                    on: {
                      click: function($event) {
                        _vm.showFeature("pro", "moreFeaturesPro", "featuresPro")
                      }
                    }
                  },
                  [
                    _c("h5", [_vm._v("Show Features")]),
                    _c("i", { staticClass: "fa fa-chevron-down" })
                  ]
                )
              ]),
              _vm._m(14),
              _vm._m(15)
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showingPersecond || !_vm.showingBlendeo,
                    expression: "showingPersecond || !showingBlendeo"
                  }
                ],
                staticClass: "gridItem",
                attrs: { id: "business" }
              },
              [
                _vm._m(16),
                _vm._m(17),
                _vm.showingMonthly
                  ? _c("div", { staticClass: "gridItem--pricing" }, [
                      _c("h4", [
                        _vm._v(_vm._s(_vm.businessMonthly)),
                        _c("span", [_vm._v(" / month")])
                      ]),
                      _c("p", [
                        _vm._v(
                          "Save " + _vm._s(_vm.businessYearlySave) + " with"
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "link",
                            on: {
                              click: function($event) {
                                _vm.showYearly()
                              }
                            }
                          },
                          [_vm._v(" yearly billing")]
                        )
                      ])
                    ])
                  : _vm._e(),
                !_vm.showingMonthly
                  ? _c("div", { staticClass: "gridItem--pricing" }, [
                      _c("h4", [
                        _vm._v(_vm._s(_vm.businessYearlyPerMonth)),
                        _c("span", [_vm._v(" / month")])
                      ]),
                      _c("p", [
                        _vm._v(_vm._s(_vm.businessYearly) + " billed yearly.")
                      ]),
                      _c("p", [
                        _vm._v(
                          "Save " + _vm._s(_vm.businessYearlySave) + " over"
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "link",
                            on: {
                              click: function($event) {
                                _vm.showMonthly()
                              }
                            }
                          },
                          [_vm._v(" monthly billing")]
                        )
                      ])
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "gridItem--pricing" },
                  [
                    _vm.showingMonthly
                      ? _c("buy-button", {
                          attrs: {
                            classes: "btn btn--purpleLight",
                            product: "fbp-m",
                            copy: "Buy Now"
                          }
                        })
                      : _vm._e(),
                    !_vm.showingMonthly
                      ? _c("buy-button", {
                          attrs: {
                            classes: "btn btn--purpleLight",
                            product: "fbp-y",
                            copy: "Buy Now"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _c("div", { staticClass: "gridItem--subtitle" }, [
                  _c("h5", { staticClass: "includeTitleDesktop" }, [
                    _vm._v("Includes:")
                  ]),
                  _c("h5", { staticClass: "includeTitleMobile" }, [
                    _vm._v("Includes:")
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "moreFeatures",
                      attrs: { id: "moreFeaturesBusiness" },
                      on: {
                        click: function($event) {
                          _vm.showFeature(
                            "business",
                            "moreFeaturesBusiness",
                            "featuresBusiness"
                          )
                        }
                      }
                    },
                    [
                      _c("h5", [_vm._v("Show Features")]),
                      _c("i", { staticClass: "fa fa-chevron-down" })
                    ]
                  )
                ]),
                _vm._m(18),
                _vm._m(19)
              ]
            )
          ])
        ])
      ]),
      _c("section", { staticClass: "pricing__callout" }, [
        _c("div", { staticClass: "pricing__callout--video" }, [
          _c(
            "div",
            { staticClass: "pricing__callout--text" },
            [
              _vm._m(20),
              _c("p", [
                _vm._v(
                  "Our Enterprise plans include additional cinemagraph solutions, such as stills-to-motion campaigns, consultation with the experts at Flixel Studios, multiple subscriptions for your entire team, and more."
                )
              ]),
              _c("router-link", { attrs: { to: "/enterprise" } }, [
                _c("button", { staticClass: "btn btn--white" }, [
                  _vm._v("Learn More")
                ])
              ])
            ],
            1
          ),
          _c("div", { staticClass: "pricing__overlay--shadow" }),
          _c("iframe", {
            staticClass: "mobileVideo",
            attrs: {
              "data-src":
                "https://media.flixel.com/cinemagraph/ed55jyjd0qe0dd4icx64?hd=true",
              allow: "autoplay"
            }
          }),
          _c("iframe", {
            staticClass: "desktopVideo",
            attrs: {
              "data-src":
                "https://media.flixel.com/cinemagraph/o0dzpxdzkx7jcndvnd80?hd=true",
              allow: "autoplay"
            }
          })
        ])
      ]),
      _vm._m(21),
      _vm._m(22),
      _vm._m(23)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gridItem--image" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          "data-src":
            "https://cdn.flixel.com/static/static-web/products/pricing/mobile.png"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gridItem--title" }, [
      _c("h2", [_vm._v("Blendeo")]),
      _c("h3", [_vm._v("Create Moving Long Exposures")]),
      _c("p", [
        _vm._v(
          "An advanced long exposure editor for iOS. Take control and change exposure time in post for motion blur or light trail photos or videos."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gridItem__products" }, [
      _c("div", { staticClass: "gridItem--product gridItem--product--grey" }, [
        _c("h6", [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-src":
                "https://cdn.flixel.com/static/static-web/purchase/Check.svg"
            }
          }),
          _vm._v("Blendeo"),
          _c("span", [_vm._v(" for iOS")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "gridItem--features", attrs: { id: "featuresMobile" } },
      [
        _c("ul", { staticClass: "dashed" }, [
          _c("li", [
            _vm._v("Import a video or capture with the built-in camera")
          ]),
          _c("li", [_vm._v("Set the Exposure Time")]),
          _c("li", [_vm._v("Adjust the timeline")]),
          _c("li", [_vm._v("Export as H.264, HEVC, PNG, GIF, or Live Photo")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gridItem--image" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          "data-src":
            "https://cdn.flixel.com/static/static-web/products/pricing/professional.png"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gridItem--title" }, [
      _c("h2", [_vm._v("Persecond")]),
      _c("h3", [_vm._v("Create beautiful time lapses effortlessly")]),
      _c("p", [
        _vm._v(
          "The easiest app to create a timelapse from a series of images for macOS."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gridItem__products" }, [
      _c("div", { staticClass: "gridItem--product gridItem--product--grey" }, [
        _c("h6", [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-src":
                "https://cdn.flixel.com/static/static-web/purchase/Check.svg"
            }
          }),
          _vm._v("Persecond"),
          _c("span", [_vm._v(" for macOS")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "gridItem--features", attrs: { id: "featuresMobile" } },
      [
        _c("ul", { staticClass: "dashed" }, [
          _c("li", [_vm._v("Import or drag and drop a set of images")]),
          _c("li", [_vm._v("Adjust the start and end frames")]),
          _c("li", [_vm._v("Set the duration and frame rate")]),
          _c("li", [_vm._v("Export as H.264, HEVC, and Apple ProRes")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gridItem--image" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          "data-src":
            "https://cdn.flixel.com/static/static-web/products/pricing/mobile.png"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gridItem--title" }, [
      _c("h2", [_vm._v("Mobile")]),
      _c("h3", [_vm._v("Small Businesses & Content Creators")]),
      _c("p", [
        _vm._v(
          "Shoot, edit, and export from your phone with the mobile cinemagraph studio."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gridItem__products" }, [
      _c("div", { staticClass: "gridItem--product gridItem--product--grey" }, [
        _c("h6", [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-src":
                "https://cdn.flixel.com/static/static-web/purchase/Check.svg"
            }
          }),
          _vm._v("Cinemagraph Pro"),
          _c("span", [_vm._v(" for iOS")])
        ])
      ]),
      _c("div", { staticClass: "gridItem--product" }, [
        _c("h6", [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-src":
                "https://cdn.flixel.com/static/static-web/purchase/Check.svg"
            }
          }),
          _vm._v("Blendeo"),
          _c("span", [_vm._v(" for iOS")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "gridItem--features", attrs: { id: "featuresMobile" } },
      [
        _c("ul", { staticClass: "dashed" }, [
          _c("li", [_vm._v("Shoot from iPhone or iPad")]),
          _c("li", [
            _vm._v("Export and share cinemagraphs on all social networks")
          ]),
          _c("li", [_vm._v("Optimized for use with Facebook Ads Manager")]),
          _c("li", [
            _vm._v("Explore 1000s of cinemagraphs in over 40 themed galleries")
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gridItem--image" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          "data-src":
            "https://cdn.flixel.com/static/static-web/products/pricing/professional.png"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gridItem--title" }, [
      _c("h2", [_vm._v("Professional")]),
      _c("h3", [_vm._v("Photographers & Marketers")]),
      _c("p", [
        _vm._v(
          "Use your computer and photography equipment to create commercial quality cinemagraphs that your clients will love."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gridItem__products" }, [
      _c("div", { staticClass: "gridItem--product gridItem--product--grey" }, [
        _c("h6", [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-src":
                "https://cdn.flixel.com/static/static-web/purchase/Check.svg"
            }
          }),
          _vm._v("Cinemagraph Pro"),
          _c("span", [_vm._v(" for iOS")])
        ])
      ]),
      _c("div", { staticClass: "gridItem--product" }, [
        _c("h6", [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-src":
                "https://cdn.flixel.com/static/static-web/purchase/Check.svg"
            }
          }),
          _vm._v("Cinemagraph Pro"),
          _c("span", [_vm._v(" for macOS")])
        ])
      ]),
      _c("div", { staticClass: "gridItem--product gridItem--product--grey" }, [
        _c("h6", [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-src":
                "https://cdn.flixel.com/static/static-web/purchase/Check.svg"
            }
          }),
          _vm._v("Persecond"),
          _c("span", [_vm._v(" for macOS")])
        ])
      ]),
      _c("div", { staticClass: "gridItem--product" }, [
        _c("h6", [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-src":
                "https://cdn.flixel.com/static/static-web/purchase/Check.svg"
            }
          }),
          _vm._v("Blendeo"),
          _c("span", [_vm._v(" for iOS")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "gridItem--features", attrs: { id: "featuresPro" } },
      [
        _c("ul", { staticClass: "dashed" }, [
          _c("li", [_vm._v("Full desktop editing experience")]),
          _c("li", [_vm._v("Upload footage from your DSLR camera")]),
          _c("li", [_vm._v("Shoot, edit, and export cinemagraphs")]),
          _c("li", [_vm._v("Create and save your own colour presets")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gridItem--image" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          "data-src":
            "https://cdn.flixel.com/static/static-web/products/pricing/business.png"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gridItem--title" }, [
      _c("h2", [_vm._v("Business")]),
      _c("h3", [_vm._v("Large Businesses & Agencies")]),
      _c("p", [
        _vm._v(
          "All of the tools and training you need to create cinemagraphs for your website, marketing, social media, and more."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gridItem__products" }, [
      _c("div", { staticClass: "gridItem--product gridItem--product--grey" }, [
        _c("h6", [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-src":
                "https://cdn.flixel.com/static/static-web/purchase/Check.svg"
            }
          }),
          _vm._v("Cinemagraph Pro"),
          _c("span", [_vm._v(" for iOS")])
        ])
      ]),
      _c("div", { staticClass: "gridItem--product" }, [
        _c("h6", [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-src":
                "https://cdn.flixel.com/static/static-web/purchase/Check.svg"
            }
          }),
          _vm._v("Cinemagraph Pro"),
          _c("span", [_vm._v(" for macOS")])
        ])
      ]),
      _c("div", { staticClass: "gridItem--product gridItem--product--grey" }, [
        _c("h6", [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-src":
                "https://cdn.flixel.com/static/static-web/purchase/Check.svg"
            }
          }),
          _vm._v("Persecond"),
          _c("span", [_vm._v(" for macOS")])
        ])
      ]),
      _c("div", { staticClass: "gridItem--product" }, [
        _c("h6", [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-src":
                "https://cdn.flixel.com/static/static-web/purchase/Check.svg"
            }
          }),
          _vm._v("Blendeo"),
          _c("span", [_vm._v(" for iOS")])
        ])
      ]),
      _c("div", { staticClass: "gridItem--product gridItem--product--grey" }, [
        _c("h6", [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-src":
                "https://cdn.flixel.com/static/static-web/purchase/Check.svg"
            }
          }),
          _vm._v("HD Cinemagraph Hosting")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "gridItem--features", attrs: { id: "featuresBusiness" } },
      [
        _c("ul", { staticClass: "dashed" }, [
          _c("li", [_vm._v("Unlimited cinemagraph uploads")]),
          _c("li", [
            _vm._v(
              "Embed perfectly looping cinemagraphs on your websites and blogs"
            )
          ]),
          _c("li", [_vm._v("Continued support and advice from Flixel")]),
          _c("li", [_vm._v("100,000 HD embed views/month")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _vm._v("Large organization?"),
      _c("br"),
      _vm._v(" Learn how Flixel works with our enterprise customers.")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "pricing__section" }, [
      _c("div", { staticClass: "pricing__faq--container" }, [
        _c("div", { staticClass: "pricing__faq--title" }, [
          _c("h2", [_vm._v("FAQ")])
        ]),
        _c("div", { staticClass: "pricing__faq--grid" }, [
          _c("div", { staticClass: "gridItem--divider" }),
          _c("div", { staticClass: "gridItem" }, [
            _c("div", { staticClass: "gridItem--title" }, [
              _c("h3", [
                _vm._v("Do you offer educational or non-profit pricing?")
              ])
            ]),
            _c("div", { staticClass: "gridItem--subtitle" }, [
              _c("h4", [_vm._v("Yes, we do!")])
            ]),
            _c("div", { staticClass: "gridItem--desc" }, [
              _c("p", [
                _vm._v(
                  "Students, teachers, nonprofit, and charitable organizations are eligible to receive a 50% discount on all products sold on the Flixel Store. Learn which products are eligible and how to apply for the discount on"
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "http://support.flixel.com/products-overview-and-pricing/purchasing/educational-and-nonprofit-pricing"
                    }
                  },
                  [_vm._v(" this page.")]
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "gridItem--divider" }),
          _c("div", { staticClass: "gridItem" }, [
            _c("div", { staticClass: "gridItem--title" }, [
              _c("h3", [
                _vm._v(
                  "Do you offer business plans with more than 100,000 embed views/month?"
                )
              ])
            ]),
            _c("div", { staticClass: "gridItem--subtitle" }, [
              _c("h4", [_vm._v("Yes, we do!")])
            ]),
            _c("div", { staticClass: "gridItem--desc" }, [
              _c("p", [
                _vm._v(
                  "Additional embed views are available in increments of 100,000. Contact us for more information about upgrading your plan."
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "gridItem--divider" }),
          _c("div", { staticClass: "gridItem" }, [
            _c("div", { staticClass: "gridItem--title" }, [
              _c("h3", [_vm._v("Will I be required to pay tax?")])
            ]),
            _c("div", { staticClass: "gridItem--subtitle" }, [
              _c("h4", [_vm._v("Possibly, but not for US or Canada.")])
            ]),
            _c("div", { staticClass: "gridItem--desc" }, [
              _c("p", [
                _vm._v(
                  "Customers in countries outside of the US or Canada may be required to pay tax on digital products."
                )
              ]),
              _c("p", [
                _vm._v(
                  "Paddle, our eCommerce provider, is required to collect VAT (Value Added Tax or Sales Tax) on digital products sold to consumers within the EU and a growing number of other countries. If you work for a VAT-registered business, learn how to submit your VAT number on"
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "http://support.flixel.com/products-overview-and-pricing/purchasing/vat-value-added-tax"
                    }
                  },
                  [_vm._v(" this page.")]
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "gridItem--divider" }),
          _c("div", { staticClass: "gridItem" }, [
            _c("div", { staticClass: "gridItem--title" }, [
              _c("h3", [_vm._v("Will the subscription renew automatically?")])
            ]),
            _c("div", { staticClass: "gridItem--subtitle" }, [
              _c("h4", [_vm._v("Yes")])
            ]),
            _c("div", { staticClass: "gridItem--desc" }, [
              _c("p", [
                _vm._v(
                  "Subscriptions renew automatically but can be cancelled at any time prior to renewal."
                )
              ]),
              _c("p", [
                _vm._v(
                  "You will be sent an email reminder a few weeks before your subscription renews. You can cancel your plan at any time and continue using it for the remainder of the subscription period."
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "gridItem--divider" })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "pricing__callout pricing__callout--footer" },
      [
        _c("div", { staticClass: "pricing__callout--video" }, [
          _c(
            "div",
            {
              staticClass: "pricing__callout--text pricing__callout--lefttext"
            },
            [
              _c("h2", [
                _vm._v("Start Making Cinemagraphs with Cinemagraph Pro")
              ]),
              _c("p", [
                _vm._v(
                  "Create thumb-stopping visuals to use on your website, social, presentations and more. Get started today with a free trial of Cinemagraph Pro."
                )
              ])
            ]
          ),
          _c("div", { staticClass: "pricing__overlay--shadow" }),
          _c("iframe", {
            staticClass: "mobileVideo",
            attrs: {
              "data-src":
                "https://media.flixel.com/cinemagraph/csn656rpj8c1nfsbzl0n?hd=true",
              allow: "autoplay"
            }
          }),
          _c("iframe", {
            staticClass: "desktopVideo",
            attrs: {
              "data-src":
                "https://media.flixel.com/cinemagraph/csn656rpj8c1nfsbzl0n?hd=true",
              allow: "autoplay"
            }
          })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "pricing__footer" }, [
      _c("div", { staticClass: "footer--text" }, [
        _c("h2", [_vm._v("Start Making Cinemagraphs with Cinemagraph Pro")]),
        _c("p", [
          _vm._v(
            "Create thumb-stopping visuals to use on your website, social, presentations and more. Get started today with a free trial of Cinemagraph Pro."
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa5bbe96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa5bbe96","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/pricing.vue
// module id = null
// module chunks = 